<!--
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
-->
<app-dialog-banner text="{{config.title}} Picklist" [dialogRef]="dialogRef"></app-dialog-banner>
<mat-dialog-content [style.height.px]="height" [style.width.px]="width" data-pick-dialog
  [attr.data-form-ready]="ready ? 'true' : null">
  @if (config.objectFactory) {
  @if (!addOnly) {
  <mat-tab-group mat-align-tabs="start" mat-stretch-tabs="false">
    <mat-tab label="Select {{config.title}}" i18n-label>
      <ng-container *ngTemplateOutlet="tableView">
      </ng-container>
    </mat-tab>
    @if (config.objectFactory) {
    <mat-tab label="New {{config.title}}" i18n-label>
      <app-form [config]="config" [dialogRef]="dialogRef"></app-form>
    </mat-tab>
    }
  </mat-tab-group>
  } @else {
  <app-form [config]="config" [dialogRef]="dialogRef"></app-form>
  }
  } @else {
  <!-- h2 mat-dialog-title i18n>Select {{config.title}}</h2 -->
  <ng-container *ngTemplateOutlet="tableView">
  </ng-container>
  }
</mat-dialog-content>
<ng-template #tableView>
  @if (prompt) {
    <p class="pick-prompt">{{prompt}}</p>
  }
  @if (showSearch) {
  <div class="pick-search">
    <mat-icon>search</mat-icon>
    <input #searchInput id="search" type="text" (input)="filter($event.target.value)" autocomplete="off"
      placeholder="Search {{config.title}}" i18n-placeholder>
  </div>
  }
  @if (dataSource) {
    <p class="pick-hint">
      @if (matchCount === 0) {
        <ng-container i18n>No matches found.</ng-container>
      } @else if (limited) {
        <ng-container i18n>Showing the first {{displayLimit}} of {{matchCount}} matches — type to narrow the list.</ng-container>
      } @else {
        <ng-container i18n>Showing all {{matchCount}} matches.</ng-container>
      }
    </p>
  }
  <table mat-table [dataSource]="dataSource" style="width:100%" class="ouromc-table">
    @for (field of columns; track field; let colIndex = $index) {
    <ng-container [matColumnDef]="field.name">
        <th mat-header-cell *matHeaderCellDef>{{field.cellOpts.heading}}</th>
        <td mat-cell *matCellDef="let focusItem" [matTooltip]="field.toolTip" [style]="field.cellOpts.style"
            [width]="field.cellOpts.width">
            <app-table-cell [field]="field" [focusItem]="focusItem"></app-table-cell>
        </td>
    </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnNames;" style="height: 48px"></tr>
    <tr mat-row *matRowDef="let row; columns: columnNames;" (click)="selectItem(row, $event)" style="height: 48px"></tr>
  </table>
</ng-template>
